import { createSlice, createAsyncThunk, } from '@reduxjs/toolkit';
import { getApiClient } from '../../utils/apiClient';
// Async thunks
const saveWebPushSubscription = createAsyncThunk('webpush/saveWebPushSubscription', async ({ subscription, alarmType, }) => {
    const response = await getApiClient()({
        url: '/api/webpush-subscribe',
        method: 'post',
        data: { subscription, alarmType },
    });
    return response.data;
});
const updateWebPushSubscription = createAsyncThunk('webpush/updateWebPushSubscription', async ({ webpushSub }) => {
    const response = await getApiClient()({
        url: '/api/webpush-update',
        method: 'post',
        data: { webpushSub },
    });
    return response.data;
});
const removeWebPushSubscription = createAsyncThunk('webpush/removeWebPushSubscription', async ({ auth }) => {
    const response = await getApiClient()({
        url: '/api/webpush-unsubscribe',
        method: 'post',
        data: { auth },
    });
    return response.data;
});
const testWebPush = createAsyncThunk('webpush/testWebPush', async () => {
    const response = await getApiClient()({
        url: '/api/test-webpush',
        method: 'post',
    });
    return response.data;
});
const addWebPushCue = createAsyncThunk('webpush/addWebPushCue', async ({ stage, alarmInSec, }) => {
    const response = await getApiClient()({
        url: '/api/webpush-cue-add',
        method: 'post',
        data: { stage, alarmInSec },
    });
    return response.data;
});
const removeWebPushCue = createAsyncThunk('webpush/removeWebPushCue', async () => {
    const response = await getApiClient()({
        url: '/api/webpush-cue-remove',
        method: 'post',
    });
    return response.data;
});
// Initial state
const initialState = {};
// Slice
const webPushSlice = createSlice({
    name: 'webpush',
    initialState,
    reducers: {},
});
// Grouped exports
export const webPushActions = {
    ...webPushSlice.actions,
    // Async actions
    saveWebPushSubscription,
    updateWebPushSubscription,
    removeWebPushSubscription,
    testWebPush,
    addWebPushCue,
    removeWebPushCue,
};
export const webPushSelectors = {};
// Export reducer
export default webPushSlice.reducer;
